import { render, staticRenderFns } from "./ReleasesModalComponent.vue?vue&type=template&id=3dd54630&"
import script from "./ReleasesModalComponent.vue?vue&type=script&lang=js&"
export * from "./ReleasesModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports